// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"b2bf91d8","518":"722256dd","537":"87469077","832":"20f9e661"}[chunkId] + ".chunk.css";
};